<template>
  <v-dialog persistent v-model="dialog" width="520">
    <v-card class="date-selector-card">
      <div class="date-selector-header">
        <div>
          <div class="date-selector-title">Select Date</div>
          <div class="date-selector-subtitle">Choose a date range for this report.</div>
        </div>

        <v-btn icon small @click="setDateSelector(false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="pa-4">
        <DateTimePicker
          defaultRange="thisMonth"
          :range="true"
          :hideTime="true"
          v-model="dateTime"
        />
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn rounded text @click="setDateSelector(false)">Cancel</v-btn>
        <v-btn rounded color="primary" dark @click="createReport">
          Create Report
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const DateTimePicker = () => import("@/components/DateTimePicker");
import { mapGetters, mapActions } from "vuex";

export default {
  name: "report-date-selector",

  props: ["CustomerId"],

  components: {
    DateTimePicker,
  },

  data() {
    return {
      dialog: false,
      dateTime: {
        start: null,
        end: null,
      },
    };
  },

  computed: {
    ...mapGetters("reportView", ["getDateSelector"]),

    dateSelector: {
      get() {
        return this.getDateSelector;
      },
      set(val) {
        this.setDateSelector(val);
      },
    },
  },

  watch: {
    dateSelector(val) {
      this.dialog = val;
    },

    dialog(val) {
      if (!val) {
        return;
      }

      const hasStart = !!(this.dateTime && this.dateTime.start);
      const hasEnd = !!(this.dateTime && this.dateTime.end);

      if (!hasStart || !hasEnd) {
        this.dateTime = {
          start: this.$moment().startOf("month").toISOString(),
          end: this.$moment().endOf("month").toISOString(),
        };
      }
    },
  },

  methods: {
    ...mapActions("reportView", ["setDateSelector"]),

    createReport() {
      this.$emit("submit", this.dateTime);
      this.setDateSelector(false);
    },
  },
};
</script>

<style scoped>
.date-selector-card { border-radius: 20px; overflow: hidden; }
.date-selector-header { padding: 16px; display: flex; align-items: center; justify-content: space-between; gap: 16px; border-bottom: 1px solid #e2e8f0; background: #f8fafc; }
.date-selector-title { font-size: 18px; font-weight: 800; color: #0f172a; }
.date-selector-subtitle { font-size: 13px; color: #64748b; margin-top: 2px; }
</style>
